import { lazy, Suspense } from 'react';
import type { PublicApi } from '../lib/api.ts';
import type { AiApi } from '../lib/aiApi.ts';
import { salaRoutes } from '../features/sala/lazy.tsx';
import { NotFound } from './NotFound.tsx';
import { Router, type Route } from './router.tsx';

// Cada carril se descarga solo cuando se usa: el celular de la sala no baja la página pública ni al revés.
const DemoIndex = lazy(() => import('../features/public/DemoIndex.tsx').then((m) => ({ default: m.DemoIndex })));
const PublicEventRoute = lazy(() => import('../features/public/PublicEventRoute.tsx').then((m) => ({ default: m.PublicEventRoute })));
const CreateDescribeRoute = lazy(() => import('../features/create/CreateDescribeRoute.tsx').then((m) => ({ default: m.CreateDescribeRoute })));
const CreateDraftRoute = lazy(() => import('../features/create/CreateDraftRoute.tsx').then((m) => ({ default: m.CreateDraftRoute })));

export function App({ api, ai }: { api: PublicApi; ai: AiApi }) {
  // Orden: rutas fijas antes que `/:account/:event`. Carriles: create → /app/eventos/nuevo, live → /sala/…, organizer → /app/…
  const routes: Route[] = [
    { pattern: '/', render: () => <Suspense fallback={null}><DemoIndex api={api} /></Suspense> },
    { pattern: '/app/eventos/nuevo', render: () => <Suspense fallback={null}><CreateDescribeRoute ai={ai} /></Suspense> },
    { pattern: '/app/eventos/nuevo/:generationId', render: (p) => <Suspense fallback={null}><CreateDraftRoute key={p.generationId} ai={ai} generationId={p.generationId!} /></Suspense> },
    ...salaRoutes(),
    { pattern: '/:account/:event', render: (p) => <Suspense fallback={null}><PublicEventRoute key={`${p.account}/${p.event}`} api={api} accountSlug={p.account!} eventSlug={p.event!} /></Suspense> },
  ];
  return <Router routes={routes} fallback={<NotFound />} />;
}
